import type { WorkoutSetSequenceItem } from '~/workout/hooks/useWorkoutSetSequence';

/**
 * Finds the currently active (first non-completed) set in a workout sequence
 */
export const findActiveSet = (
  sequence: WorkoutSetSequenceItem[],
): WorkoutSetSequenceItem | undefined => {
  return sequence.find((item) => !item.set.completedAt);
};

/**
 * Finds the next non-completed set in the sequence, ignoring the set identified
 * by `excludeKey` (e.g. the one that was just completed but whose live data may
 * not have updated yet). Returns undefined when no other set remains.
 */
export const findNextIncomplete = (
  sequence: WorkoutSetSequenceItem[],
  excludeKey: string,
): WorkoutSetSequenceItem | undefined => {
  return sequence.find(
    (item) => item.key !== excludeKey && !item.set.completedAt,
  );
};
